import { render, staticRenderFns } from "./MainActions.vue?vue&type=template&id=6b3d55ac&scoped=true"
import script from "./MainActions.vue?vue&type=script&lang=js"
export * from "./MainActions.vue?vue&type=script&lang=js"
import style0 from "./MainActions.vue?vue&type=style&index=0&id=6b3d55ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d55ac",
  null
  
)

export default component.exports